// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ncrea","padding":"styles_padding__6oZP4","paddingDownload":"styles_paddingDownload__oKvT6"};